import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-sol bg-cielo" data-id="element-108" data-mp="8mdmfcb6rh3m">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-109" data-mp="dg86whym803r">
        <p className="inline-block rounded-md bg-coral px-2 py-0.5 font-sub text-sm font-semibold leading-tight text-white" data-id="element-110" data-mp="icgijldltb66">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-[1.5rem] font-extrabold uppercase leading-[1.1] tracking-tight text-navy sm:text-4xl" data-id="element-111" data-mp="rey0hnm87hnd">
          Comenzá hoy desde cero y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-2xl border-4 border-dashed border-navy bg-white text-navy" data-id="element-112" data-mp="2t7m6g4q98j6u">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block bg-white focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-coral" data-id="element-113" data-mp="12n8mtwmk42n9">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos y 5 bonos incluidos`} className="block w-full" data-id="element-114" data-mp="svmeq95imjoq" />
          </a>
          <div className="p-3" data-id="element-115" data-mp="1lluopdpwdxs8">
            <p className="font-sub text-sm font-bold uppercase leading-tight text-navy" data-id="element-116" data-mp="1gn9wo1ksukev">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 inline-block rounded-md bg-sol px-2 py-0.5 font-display text-2xl font-black uppercase leading-tight text-navy" data-id="element-117" data-mp="1ckwoz7mhscfg">
              6 Tomos + 5 Bonos
            </p>
            <p className="mt-1 text-xs font-semibold text-navy/80 sm:text-sm" data-id="element-118" data-mp="16szoequncgq">
              🎁 Bonos valorados en{' '}
              <span className="line-through decoration-coral decoration-2" data-id="element-119" data-mp="3sc155pnldmlt">{BONUS_TOTAL}</span>
            </p>

            <p className="mt-2 inline-block rounded-full bg-navy px-3 py-0.5 font-sub text-xs font-bold uppercase text-sol" data-id="element-120" data-mp="3tuixkq6i9alc">
              🔥 Oferta especial
            </p>
            <p className="mx-auto mt-1 w-fit rounded-xl border-2 border-navy bg-coral px-3 py-1 font-display text-5xl font-black leading-none text-white sm:text-6xl" data-id="element-121" data-mp="3ku30pzk9p1pg">
              <span className="text-2xl sm:text-3xl" data-id="element-122" data-mp="3b3hze4d7lj2u">Hoy:</span> {PRICE}
            </p>
            <p className="mt-1.5 text-xs font-semibold text-navy/80" data-id="element-123" data-mp="3b1ot4q6id0vd">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-124" data-mp="316dcu3fgblli">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>
            <p className="mt-2.5 text-xs font-semibold text-navy/80" data-id="element-125" data-mp="2s4w08v19621k">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}